import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { AirtableFieldDateOptionsTimeFormat } from "@/types/crm/tables/question";
import { useEffect, useState } from "react";


export function DateTimeForm() {
    const { isFormDisabled, form } = useFieldFormContext();
    const field_date_options = form?.watch('field_date_options');
    const [timeFormat, setTimeFormat] = useState<string>(field_date_options?.timeFormat ?? "h:mma")
    console.log(form.formState.errors)
    console.log(timeFormat)
    useEffect(() => {
        setTimeFormat("h:mma")
    }, [])
    useEffect(() => {
        form?.setValue("field_date_options.timeFormat", timeFormat)
    }, [form, timeFormat])

    return (
        <div className="flex flex-col gap-2">
            <p className="text-sm font-medium">Time Format</p>
            <Select
                value={timeFormat}
                onValueChange={setTimeFormat}
                disabled={isFormDisabled}
            >
                <SelectTrigger className="w-full mb-1" autoComplete="off">
                    <SelectValue placeholder="Select duration format" />
                </SelectTrigger>
                <SelectContent>
                    {Object.entries(AirtableFieldDateOptionsTimeFormat).map(([value, label]) => (
                        <SelectItem key={value} value={label}>
                            {value}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    )
}